import React, { Component } from 'react';
import {Button} from '@betareader/design-system';
import { withRouter } from 'react-router-dom';

import { withTranslation } from 'react-i18next';

// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  fetchAccountUsers,
  removeAccountUser
} from '../../../modules/account';

import InviteAccountMemberModal from './inviteAccountMemberModal';
import { authUtil } from '../../../utils';
import AppIcon from '../../../components/AppIcon';

export class AccountMembersTable extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchAccountUsers();
  }

  fetchAccountUsers = async () => {
    const { userProfile } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    if (userProfile) {
      this.props.fetchAccountUsers({
        idToken,
        accountId: userProfile.account && userProfile.account._id
      });
    }
  }

  deleteUser = async accountUser => {
    const idToken = await authUtil.getFreshIdToken();
    this.props.removeAccountUser({
      idToken,
      accountId: accountUser.account,
      userId: accountUser.user._id
    });
  }

  render() {
    const {
      userProfile, user, t, accountUsers
    } = this.props;
    if (user !== undefined && userProfile !== undefined) {
      return (
        <React.Fragment>
          <h2>{t('Members')}</h2>
          <table className='br-table' aria-label={t('Members')}>
            <thead>
              <tr>
                <th scope='col'>{t('Name')}</th>
                <th scope='col'>{t('Role')}</th>
                <th scope='col'>{t('Actions')}</th>
              </tr>
            </thead>
            <tbody>
              {
                accountUsers && accountUsers.map(accountUser => (
                  <tr key={accountUser._id}>
                    <td>{accountUser.user.displayName || t('Unnamed')}</td>
                    <td>{t(`member_role_${accountUser.role}`)}</td>
                    <td>
                      {
                        accountUser.user._id !== userProfile._id && (
                          <Button
                            variant='ghost'
                            size='small'
                            aria-label={`${t('Remove')} ${accountUser.user.displayName || t('Unnamed')}`}
                            onClick={() => this.deleteUser(accountUser)}
                          ><AppIcon name='trash' aria-hidden='true' /></Button>
                        )
                      }
                    </td>
                  </tr>
                ))
              }
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={3}>
                  <InviteAccountMemberModal />
                </td>
              </tr>
            </tfoot>
          </table>
        </React.Fragment>
      );
    }
    return null;
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  readerBonusList: state.readerBonus.readerBonusList,
  accountUsers: state.account.accountUsers
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchAccountUsers,
  removeAccountUser
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountMembersTable)));
